(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/views/package-rows-container.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/views/package-rows-container.js');

'use strict';

svs.keno.components.play.views.PackageRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content padding-xs-h-1 padding-xs-bottom-2 padding-md-bottom-0 padding-md-h-2 padding-top-2',
  regions: {
    sizePickerRegion: '#sizePickerRegion',
    packageRowsRegion: '#packageRowsRegion',
    packageHuxfluxRegion: '#packageHuxfluxRegion',
    campaignCardRegion: '#campaignCardRegion'
  },
  template(data) {
    return svs.keno.components.play.templates.package_rows_container(data);
  },
  onRender() {
    this.showChildView('sizePickerRegion', new svs.numbergames.game.views.SizePicker({
      model: this.model,
      invertButtons: true
    }));
    this.showChildView('packageRowsRegion', new svs.numbergames.game.views.PackageRows({
      className: 'package-rows package-rows-keno grid-row',
      model: this.model,
      ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 200 : 150
    }));
    this.showChildView('packageHuxfluxRegion', new svs.numbergames.game.views.PackageHuxfluxButton({
      model: this.model
    }));
    this.showChildView('campaignCardRegion', new svs.numbergames.game.views.CampaignCard({
      model: this.model,
      className: 'margin-top-2'
    }));
  }
});

 })(window);